// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
*,
*::before,
*::after {
  box-sizing: border-box;
}
html,
body,
#app {
  height: 100%;
  margin: 0;
}
body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  background: #ededed;
}
button {
  cursor: pointer;
}
button:disabled {
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/App.vue"],"names":[],"mappings":";AASA;;;EAGE,sBAAsB;AACxB;AAEA;;;EAGE,YAAY;EACZ,SAAS;AACX;AAEA;EACE;cACY;EACZ,mCAAmC;EACnC,mBAAmB;AACrB;AAEA;EACE,eAAe;AACjB;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["<script setup lang=\"ts\">\nimport { RouterView } from 'vue-router'\n</script>\n\n<template>\n  <RouterView />\n</template>\n\n<style>\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nhtml,\nbody,\n#app {\n  height: 100%;\n  margin: 0;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  background: #ededed;\n}\n\nbutton {\n  cursor: pointer;\n}\n\nbutton:disabled {\n  cursor: not-allowed;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
